



























import Card from "@/components/layout/card.vue";
import { defineComponent, ref } from "@vue/composition-api";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import { useRouter } from "@/router/router";
import { useCommittable } from "@/composables/committable";
import { Team, Zone } from "@/swagger/models";
import { zoneService } from "@/services/zone";
import DesksTable from "@/components/tables/desks-table.vue";
import ZoneRestrictions from "@/components/zones/zone-restrictions.vue";
import { userService } from "@/services/user";
import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import TabsZone from "@/components/tabs/zone.vue";
import alert from "@/components/misc/alert.vue";

export default defineComponent({
    name: "zones",
    props: {},
    components: { alert, Card, TabsZone, CommitResetBar, ZoneRestrictions, Page, PageHeader, DesksTable },
    setup(props, context) {
        const loading = ref(true);
        const zone = ref<Zone>();
        const teams = ref<Team[]>([]);
        const { route, router } = useRouter(context);

        const { clone, commit, revert, isDirty } = useCommittable<Zone>({
            originalValue: zone,
            watchOriginal: true,
            async onCommit() {
                try {
                    loading.value = true;

                    if (clone.value.id) {
                        return await zoneService.patch(zone.value.id, clone.value);
                    } else {
                        const zone = await zoneService.create(clone.value);
                        await router.replace({ params: { zoneId: zone.id.toString() } });
                        return zone;
                    }
                } catch (e) {
                    // The service will have handled showing a toast at this point
                    // console.warn(e);
                } finally {
                    loading.value = false;
                }
            },
        });

        (async () => {
            if (route.value.params.zoneId !== "new") {
                zone.value = await zoneService.get(parseInt(route.value.params.zoneId));
            } else {
                zone.value = await zoneService.build({
                    // @ts-ignore
                    floor: parseInt(route.value.params.floorId),
                });
            }

            revert(true);
            loading.value = false;
        })();

        const zoneTypes = [
            { label: "Work area", value: "workArea" },
            { label: "Meeting room", value: "meetingRoom" },
            { label: "Canteen", value: "canteen" },
            { label: "Gym", value: "gym" },
            { label: "Lounge", value: "lounge" },
            { label: "Parking", value: "parking" },
        ];

        const deleteZone = async () => {
            if (!zone.value.id) return; //
            if (!confirm("Are you sure you want to delete this zone?")) return;
            await zoneService.delete(zone.value.id);
            await router.replace({ name: "floor" });
        };

        return { loading, zone, clone, commit, revert, teams, isDirty, zoneTypes, deleteZone };
    },
});
